'use client';

import { FC } from 'react';
import { Clock } from 'lucide-react';
import styles from './PlanUnitOption.module.scss';
const PLAN_UNIT_ICON_SRC: Record<string, string | undefined> = {
  hour: undefined,
  day: '/assets/icons/daily.svg',
  month: '/assets/icons/monthly.svg',
  annual: '/assets/icons/Newannualy.svg'
};
export interface PlanUnitOptionProps {
  unit: string;
  label: string;
  iconSize?: number;
}
const PlanUnitOption: FC<PlanUnitOptionProps> = ({
  unit,
  label,
  iconSize = 18
}) => {
  const iconSrc = PLAN_UNIT_ICON_SRC[unit];
  return <span className={styles.label} data-sentry-component="PlanUnitOption" data-sentry-source-file="PlanUnitOption.tsx">
            {iconSrc ?
    // eslint-disable-next-line @next/next/no-img-element
    <img src={iconSrc} alt="" width={iconSize} height={iconSize} className={styles.icon} /> : <Clock size={iconSize} strokeWidth={2} />}
            {label}
        </span>;
};
export default PlanUnitOption;